import { Card, CardHeader, CardHeading } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppNotificationForm } from "../appNotifications/AppNotificationForm";
import { useAppNotification } from "../appNotifications/useAppNotification";
import { AppNotificationActionType, AppNotificationFormValues } from "../shared/types/appNotification";
import { RecipientType } from "../shared/types/recipient";

const initialValues: AppNotificationFormValues = {
	actionType: AppNotificationActionType.NONE,
	actionValue: undefined,
	recipientType: RecipientType.ALL_DEVICES_WITH_USERS,
	body: "",
	title: "",
	selectedRecipients: [],
	event: null,
	showSendAt: false,
	sendAt: null,
};

export const AppNotificationCreatePage: FC = () => {
	const { t } = useTranslation();
	const { handleCreate } = useAppNotification();

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Create notification")}</CardHeading>
			</CardHeader>
			<AppNotificationForm appNotification={initialValues} handleSubmit={handleCreate} disabled={false} />
		</Card>
	);
};
